'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { Card, CardImg, CardBody, CardTitle, CardText, ListGroupItem, ListGroup } from 'reactstrap';
import { MdEmail, MdLocalPhone } from 'react-icons/md';
import { LinkedinIcon } from 'react-share';
import { getI18nUtils } from '../i18n/i18n-utils';
import { getColleagueByName } from '../api/colleagues';
import { useEffect, useState } from 'react';

export type Colleague = {
  firstName: string;
  lastName: string;
  jobTitle: string;
  email: string;
  cellphone: string;
  telephone: string;
  linkedIn: string;
  portraitImg: {
    path: string;
  };
};

const SandYouJobOwner = ({ owner, className, dictionary }) => {
  const [publicationOwner, setPublicationOwner] = useState<Colleague | null>(null);
  const { formatMessage } = getI18nUtils(dictionary);
  const ownerName = owner?.emailAddressBusiness?.split('@')[0].toLowerCase();

  useEffect(() => {
    if (!ownerName) return;
    const fetchPublicationOwner = async () => {
      const ownerData = await getColleagueByName(ownerName);
      setPublicationOwner(ownerData);
    };
    fetchPublicationOwner();
  }, [ownerName]);

  if (!publicationOwner) return null;
  const { firstName, email, telephone, linkedIn, portraitImg } = publicationOwner;
  const portrait = portraitImg?.path;

  return (
    <Card className={`${className || ''}`}>
      <CardImg
        className="rounded-0"
        src={portrait}
        title={firstName}
        style={{ height: 400, objectFit: 'cover', objectPosition: '0px -50px' }}
      />
      <CardBody className="m-3">
        <CardTitle tag="h4" className="mb-3">
          {`${formatMessage({ id: 'job_detail_contact' })} ${firstName}`}
        </CardTitle>
        <CardText className="border-bottom pb-4">{formatMessage({ id: 'job_detail_contact_phrase' })}</CardText>
        <ListGroup>
          <ListGroupItem className="border-0 px-0">
            <a href={`mailto:${email}`}>
              <MdEmail size="20" color="#A6B7C4" className="me-2" />
              {email}
            </a>
          </ListGroupItem>
          <ListGroupItem className="border-0 p-0">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <a href={`tel:${telephone}`}>
                  <MdLocalPhone size="20" color="#A6B7C4" className="me-2" />
                  {telephone}
                </a>
              </div>
              <div>
                <a href={linkedIn} target="_blank" rel="noopener noreferrer">
                  <LinkedinIcon size={32} round />
                </a>
              </div>
            </div>
          </ListGroupItem>
        </ListGroup>
      </CardBody>
    </Card>
  );
};

export default SandYouJobOwner;
